export default "__VITE_ASSET__D2efcV$p__"